/**
 * Represents a tax class for a product, or in other words,
 * the category of the product for tax purposes.
 *
 * Generally, these values will correspond to `taxCodes` in AvaTax.
 * @see {@link https://taxcode.avatax.avalara.com/ Avalara Tax Codes Search}
 */
enum TaxClass {
  /** General clothing and related products for B2C (Avalara code: PC040100). */
  GeneralClothing,

  /** Shoes and laces for B2C (Avalara code: PC040144). */
  ShoesAndLaces,

  /** Shoe inserts for B2C (Avalara code: PC040145). */
  ShoeInserts,

  /** Children's clothing for B2C (Avalara code: PC040500). */
  ChildrenClothing,

  /** Shoe insoles for B2C (Avalara code: PC040131). */
  ShoeInsoles,

  /** Gift certificates (Avalara code: PG050000). */
  GiftCertificates
}

export default TaxClass;
